import { configureStore } from "@reduxjs/toolkit";
import { rootReducer as reducer } from "realwarebinder";

export const store = configureStore({
  reducer,
});
